import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('forms');

const formsRoutes = [
  {
    path: '/forms',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '',
        name: 'forms',
        props: true,
        component: loadView('FormCollections'),
      },
      {
        path: 'collections/:collectionId',
        name: 'collection-detail',
        props: true,
        component: loadView('formCollections/CollectionDetail'),
      },
      {
        path: ':formId',
        name: 'form-detail',
        props: true,
        component: loadView('forms/FormDetail'),
      },
    ],
  },
];

export default formsRoutes;
